import React from "react";
import { useTranslation } from "react-i18next";
import urlPatterns from "../../../urls";
import ButtonLink from "../../atoms/ButtonLink";
import StyledSideTrayHeader from "../../atoms/StyledSideTrayHeader";
import { WinesAddBottleTrayFooter, WinesAddBottleTrayFooterItem } from "../../atoms/WinesAddBottleTrayFooter";
import cellarBottleImg from "../../../assets/images/temp/bottle-xl-vertical.png";
import RotatingBottleBox from "../../atoms/RotatingBottleBox";

import { I18N_NAMESPACES } from "../../../helpers/constants";
import { StyledSideTray, WinesAddBottleTrayBody } from "./style";

interface ProductAddTrayProps {
  isInBoxAndCartTray: boolean;
  isOpened: boolean;
  onCloseTray: () => void;
  bgColor: string;
  bottleImage: string | null;
  addBottleToBoxButtonComponent?: React.ReactNode | null;
  addBottleToCartButtonComponent?: React.ReactNode | null;
  variant?: "wineProduct" | "nonWineProduct";
}

const ProductAddTray = ({
  isInBoxAndCartTray,
  isOpened,
  onCloseTray,
  bgColor,
  bottleImage,
  addBottleToBoxButtonComponent = null,
  addBottleToCartButtonComponent = null,
  variant = "wineProduct",
}: ProductAddTrayProps) => {
  const { t } = useTranslation([I18N_NAMESPACES.COMMON]);

  const shouldDisplayAddToBoxButton = !!addBottleToBoxButtonComponent;
  const shouldDisplayAddToCartButton = !!addBottleToCartButtonComponent;

  return (
    <StyledSideTray
      shouldAnimate
      isInBoxAndCartTray={isInBoxAndCartTray}
      isOpened={isOpened}
      onClickBackdrop={() => onCloseTray()}
    >
      <StyledSideTrayHeader title={t("common:addBottle")} handleChange={onCloseTray} />
      <WinesAddBottleTrayBody backgroundColor={bgColor}>
        <RotatingBottleBox
          imgUrl={bottleImage || cellarBottleImg}
          rotateMobile={variant === "wineProduct"}
          isImageVertical={variant === "nonWineProduct"}
        />
      </WinesAddBottleTrayBody>
      <WinesAddBottleTrayFooter>
        <WinesAddBottleTrayFooterItem>
          <p> {t("common:addToMyBoxTip")}</p>

          {shouldDisplayAddToBoxButton ? (
            addBottleToBoxButtonComponent
          ) : (
            <ButtonLink to={urlPatterns.LOGIN} full lg whiteBgOnHover>
              {t("common:addToFirstBox")}
            </ButtonLink>
          )}
        </WinesAddBottleTrayFooterItem>

        <WinesAddBottleTrayFooterItem>
          <p> {t("common:addToOneOffTip")}</p>
          {shouldDisplayAddToCartButton ? (
            addBottleToCartButtonComponent
          ) : (
            <ButtonLink to={urlPatterns.LOGIN} full lg ghost>
              {t("common:addToOneOff")}
            </ButtonLink>
          )}
        </WinesAddBottleTrayFooterItem>
      </WinesAddBottleTrayFooter>
    </StyledSideTray>
  );
};

export default ProductAddTray;
